import React, { useState } from 'react';

export default function ResultTable({ data }) {
  const [page, setPage] = useState(0);
  const PAGE = 10;
  if (!data?.length) return null;

  const cols = Object.keys(data[0]);
  const totalPages = Math.ceil(data.length / PAGE);
  const rows = data.slice(page * PAGE, page * PAGE + PAGE);

  const fmtVal = (v) => {
    if (v === null || v === undefined) return <span style={s.nullVal}>null</span>;
    if (typeof v === 'number') return <span style={s.numVal}>{v.toLocaleString()}</span>;
    if (typeof v === 'boolean') return <span style={s.boolVal}>{String(v)}</span>;
    const str = String(v);
    if (str.length > 80) return <span title={str}>{str.slice(0, 80)}…</span>;
    return str;
  };

  return (
    <div style={s.wrap} className="result-table-wrap">
      <div style={s.header}>
        <span style={s.rowCount}>{data.length} row{data.length !== 1 ? 's' : ''}</span>
        {totalPages > 1 && (
          <div style={s.pagination}>
            <button onClick={() => setPage(p => Math.max(0, p-1))} disabled={page === 0} style={s.pgBtn}>‹</button>
            <span style={s.pgInfo}>{page + 1} / {totalPages}</span>
            <button onClick={() => setPage(p => Math.min(totalPages-1, p+1))} disabled={page === totalPages-1} style={s.pgBtn}>›</button>
          </div>
        )}
      </div>
      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              {cols.map(col => (
                <th key={col} style={s.th}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} style={i % 2 === 0 ? {} : s.altRow}>
                {cols.map(col => (
                  <td key={col} style={s.td}>{fmtVal(row[col])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const s = {
  wrap: {
    borderRadius: 12, border: '1px solid var(--border-subtle)',
    overflow: 'hidden', marginBottom: 12, animation: 'fadeIn 0.4s ease',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '8px 14px', background: 'var(--bg-tertiary)', borderBottom: '1px solid var(--border-subtle)',
  },
  rowCount: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, letterSpacing: '0.3px' },
  pagination: { display: 'flex', alignItems: 'center', gap: 8 },
  pgBtn: {
    width: 24, height: 24, borderRadius: 6, border: '1px solid var(--border-subtle)',
    background: 'var(--bg-secondary)', color: 'var(--text-secondary)', cursor: 'pointer',
    fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  pgInfo: { fontSize: 11, color: 'var(--text-muted)' },
  tableWrap: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12, fontFamily: 'var(--font-mono)' },
  th: {
    padding: '8px 14px', textAlign: 'left', background: 'var(--bg-tertiary)',
    color: 'var(--text-secondary)', fontWeight: 700, whiteSpace: 'nowrap',
    borderBottom: '1px solid var(--border-subtle)', fontSize: 11, letterSpacing: '0.3px',
    position: 'sticky', top: 0,
  },
  td: {
    padding: '7px 14px', color: 'var(--text-primary)', borderBottom: '1px solid var(--border-subtle)',
    whiteSpace: 'nowrap', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis',
  },
  altRow: { background: 'var(--bg-primary)' },
  nullVal: { color: 'var(--text-muted)', fontStyle: 'italic' },
  numVal: { color: 'var(--info)', fontWeight: 500 },
  boolVal: { color: 'var(--success)', fontWeight: 500 },
};
